import instance from './requst'
export function getUsername(uesrname) {
    return instance.get('/v1/users/check_username', {
        params: {
            username:uesrname
        }
    })
}
export function getCode(data) {
    return instance.post('/v1/sms/verification_code', data)
}
export function signUp(data){
    return instance.post('/v1/users/signup',data)
}
export function Login(data){
    return instance.post('/v1/users/login',data)
}
export function SetPassWord(data){
    return instance.put('/v1/users/password',data)
}
export function LoginOut(){
    return instance.post('/v1/users/logout')
}
export function SetPhone(data){
    return instance.put('/v1/users/phone',data)
}
export function SetUserInfo(data){
    return instance.put('/v1/users/profile',data)
}
export function PostUserInfo(data){
    return instance.post('/v1/users/profile',data)
}
export function BindPhone(data){
    return instance.post('/v1/users/phone',data)
}
export function SearchUser(data){
    return instance.post('/v1/users/search',data)
}
export function DeletePublicKey(id){
    return instance.delete(`/v1/users/${id}/public_key`)
}
export function DeleteUser(id){
    return instance.delete(`/v1/users/${id}`)
}